import React from "react";
import { WHATSAPP_URL } from "@/lib/site";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFab() {
  return (
    <a
      data-testid="whatsapp-fab"
      href={WHATSAPP_URL()}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] text-white rounded-full shadow-xl pl-4 pr-5 py-3 hover:scale-[1.03] transition-transform"
      aria-label="Falar no WhatsApp"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="text-sm font-semibold hidden sm:inline">WhatsApp</span>
    </a>
  );
}
